/*
 *
 * CostsShopSelector
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 02-Oct-2025
*/
import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  searchBarLabel: <PortalMessage id='t.app.shopSelector.searchBarLabel' defaultMessage='Cerca per codice, indirizzo, ...' />,
  selectAllLabel: <PortalMessage id='t.app.shopSelector.selectAllLabel' defaultMessage='Seleziona tutto' />,
  selectedLabel: <PortalMessage id='t.app.shopSelector.selectedLabel' defaultMessage='Selezionati' />,
  selectedLabelSingle: <PortalMessage id='t.app.shopSelector.selectedLabelSingle' defaultMessage='Selezionato' />,
  clearLabel: <PortalMessage id='t.app.shopSelector.clearLabel' defaultMessage='Azzera' />,
  noResultsFound: <PortalMessage id='t.app.shopSelector.noResultsFound' defaultMessage='Nessun risultato trovato.' />,
  ofLabel: <PortalMessage id='t.app.shopSelector.ofLabel' defaultMessage='di' />,
  hiddenLabel: <PortalMessage id='t.app.shopSelector.hiddenLabel' defaultMessage='label nascosta' />,
  typology: <PortalMessage id='t.app.shopSelector.typology' defaultMessage='Tipologia' />,
  resultsFoundLabel: <PortalMessage id='t.app.shopSelector.resultsFoundLabel' defaultMessage='Risultati trovati' />,
  selectAllResultsLabel: <PortalMessage id='t.app.shopSelector.selectAllResultsLabel' defaultMessage='Seleziona tutti i risultati' />
}

export default formattedMessage
